const getSelectorByGlobalId = (variablesArr, globalId) =>
  variablesArr.find((variable) => variable.globalId === globalId && variable.querySelector)
    ?.querySelector;

export default getSelectorByGlobalId;
